/**
 * @name 图标
 */
import base from '../base';
import Icon from './icon';

Icon.install = function(Vue) {
  Vue.use(base);
  Vue.component(Icon.name, Icon);
};

export default Icon;
